/* eslint-disable import/no-extraneous-dependencies */
import { withStyles } from '@mui/styles';

import muiStyles from './styles';
import { UserWalletMappingForm } from './UserWalletMappingForm';

export default withStyles(muiStyles)(UserWalletMappingForm);